import { db } from '../firebase/config';
import { doc, updateDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import type { ScoringSex } from '../../domain/users/types';

/**
 * Sets another person's scoring sex, from the admin panel.
 *
 * This is the profile only. Every workout stores the sex it was scored under in
 * `scoringSexSnapshot`, and those are not rewritten, so past points stay exactly
 * as they were and only lifts logged from now on use the new value. That gap is
 * what the admin list flags with a warning badge.
 */
export async function updateUserScoringSex(userId: string, scoringSex: ScoringSex): Promise<void> {
  await updateDoc(doc(db, 'users', userId), {
    scoringSex,
    updatedAt: serverTimestamp(),
  });
}

/**
 * Permanently removes a user profile. Called from the admin panel only.
 *
 * This orphans every workout that references the userId — they will show
 * "Unknown User" on the feed and leaderboard. The workouts themselves are
 * not deleted; use adminDeleteWorkout for that.
 */
export async function deleteUser(userId: string): Promise<void> {
  await deleteDoc(doc(db, 'users', userId));
}
